import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=63ca13ec&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ca13ec')) {
      api.createRecord('63ca13ec', component.options)
    } else {
      api.reload('63ca13ec', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=63ca13ec&", function () {
      api.rerender('63ca13ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B6pihqP2K7c4/JS/offershelp.vue"
export default component.exports